export function getRemovalScopeSelectedSymptomTreeKeys(
  inputType: string,
  selectedSxKeys: string[],
): string[] {
  // sx_collect_associated should not treat preselected primary symptoms as removal candidates.
  if (inputType === 'sx_collect_associated') {
    return [];
  }
  return selectedSxKeys;
}
